import { render } from "./PreavisCreateModal.vue?vue&type=template&id=9a8655d0&scoped=true&ts=true"
import script from "./PreavisCreateModal.vue?vue&type=script&lang=ts"
export * from "./PreavisCreateModal.vue?vue&type=script&lang=ts"

import "./PreavisCreateModal.vue?vue&type=style&index=0&id=9a8655d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a8655d0"]])

export default __exports__